import { createAction, props } from '@ngrx/store';
import { Station } from '../../stations/stations.model';

export const LoadSelectedStation = createAction(
  '[stations] Load selected station',
  props<{ station: Station }>()
);
